import {
  OperatorNotEquals,
  OperatorEquals,
  OperatorNot,
  OperatorHasAny,
  OperatorHasAll,
  OperatorIsGreaterThan,
  OperatorIsLessThan,
} from 'v2/core/services/queryBuilder/operators';
import {
  OperationType,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

export const getWhereClauseFilterOperator = (
  whereClause: WhereClause,
  isTaxonomyField: boolean,
  metadataOperator?: string,
) => {
  if (!isTaxonomyField) {
    switch (metadataOperator) {
      case 'is greater than':
        return OperatorIsGreaterThan;
      case 'is less than':
        return OperatorIsLessThan;
      default:
        return whereClause.exclude ? OperatorNotEquals : OperatorEquals;
    }
  }

  if (whereClause.exclude) {
    return OperatorNot;
  }

  if (whereClause.filter?.type === OperationType.OR) {
    return OperatorHasAny;
  } else {
    return OperatorHasAll;
  }
};
